module.exports = __webpack_public_path__ + "static/media/35f649be-b79d-4ef2-ae98-fcc99ab1500d.cd2aab8c.JPG";